import React, { useState, useEffect } from 'react';
import './CheckBoxCards.scss';
import { Manager, OperatoreBackOffice, OperatoreCommunale, RoleCard } from '../models'
import { UserRoleEnum } from '../../../../helpers/enums';
import { useRole } from '../../../../helpers/customHooks';

import 'swiper/swiper.scss';

const Card = (props: any) => {
    const { t } = props;
    const active = props.active ? 'card-radio active' : 'card-radio';
    return (
        <div className="card-radio-wrapper">
            <div className={`form-check abc-radio ${active}`}>
                <input
                  type="radio"
                  className="form-check-input"
                  name="selfReadType"
                  id={props.index}
                  value={props.title}
                  checked={props.active}
                  onChange={() => props.setChecked(props.index)}
                  aria-describedby="istruzioni_lettura"
                />
                <label  htmlFor={props.index}>
                  <div className="card-inner">
                    <h3 className="title headline-fs6">
                        {t(props.title)}
                    </h3>
                    <h4 className="subtitle paragraph-main-fs8">
                        {t(props.subtitle)}
                    </h4>
                    <ul className="d-flex flex-column">
                        {props.desc.map((desc: string, i: number) => {
                            return <li className="paragraph-main-fs8" key={i}>{t(desc)}</li>
                        })}
                    </ul>
                  </div>
                </label>
            </div>
        </div>
    )
};

const CheckboxCards = (props: any) => {
    const { t } = props;
    const [roleData, setRoleData] = useState<any>([]);
    const [activeCheckbox, setActiveCheckbox] = useState<any>(0);

    const { role } = useRole()

    const handleClick = (e: number) => {
        setActiveCheckbox(e);
        props.activeCheckbox(e)
    }


    useEffect(() => {
        if (role === UserRoleEnum.MANAGER) {
            const data = [Manager, OperatoreBackOffice, OperatoreCommunale]
            setRoleData(data)
        } else {
            const data = [OperatoreCommunale]
            setRoleData(data)
        }
        return () => { }

    }, [role])

    return roleData.length ? (
        <>
            <div className="add-role-container">
              <p className="add-role headline-bold-fs4" id="radio-group-label">{t('common.addRole')}</p>
              <div className="cards-container" data-testid="ChexboxCard" role="radiogroup" aria-labelledby="radio-group-label">
                {roleData.map((el: RoleCard, i: any) => {
                    const active = activeCheckbox === i
                    return <Card t={t} key={i} setChecked={handleClick} active={active} index={i} {...el} />
                })}
              </div>
            </div>
        </>
    ) : null;
};

export default CheckboxCards
